export const KFS_OTP = {
  kfsOtpRequest: "4321",
  kfsSuccess: "4322",
};
